module.exports = __webpack_public_path__ + "img/hr-sand-rock-big-12.a83039a8.png";